// @flow
import * as React from 'react'

export const windowStates = {
    minimized: 'minimized',
    opened: 'opened',
    maximized: 'maximized',
}

export type WindowStateType = {
    windowState: 'minimized' | 'opened' | 'maximized',
}

type Props = {
    windowState: WindowStateType,
    onChangeWindowState: Function,
    theme?: {},
    tocVisible: boolean,
    type: 'contextBar' | 'south' | 'header',
}

function WindowState(props: Props) {
    const rootClassNames = []
    let closerClass1
    let closerClass2

    const onChangeState = (clickedCloserClass) => {
        let newState
        if (clickedCloserClass.indexOf('minus') >= 0) newState = windowStates.opened
        else if (clickedCloserClass.indexOf('caret-down') >= 0) newState = windowStates.minimized
        else if (clickedCloserClass.indexOf('caret-up') >= 0) newState = windowStates.maximized
        if (!newState) console.error(`Invalid window state for ${clickedCloserClass}`)
        props.onChangeWindowState(newState)
    }

    if (props.type === 'south') {
        rootClassNames.push(props.theme.closerHorizontal)
        rootClassNames.push(props.tocVisible ? props.theme.closerContextBarOpen : props.theme.closerContextBarClosed)

        if (props.windowState === windowStates.minimized) {
            rootClassNames.push(props.theme.closerMinimized)
            closerClass1 = 'fa fa-minus'
            closerClass2 = 'fa fa-caret-up'
        } else if (props.windowState === windowStates.opened) {
            rootClassNames.push(props.theme.closerNormal)
            closerClass1 = 'fa fa-caret-down'
            closerClass2 = 'fa fa-caret-up'
        } else if (props.windowState === windowStates.maximized) {
            rootClassNames.push(props.theme.closerMaximized)
            closerClass1 = 'fa fa-caret-down'
            closerClass2 = 'fa fa-minus'
        }
    } else if (props.type === 'contextBar') {
        rootClassNames.push(props.theme.closerVertical)
        if (props.windowState === windowStates.opened) {
            closerClass1 = 'fa fa-caret-left'
        } else {
            closerClass1 = 'fa fa-caret-right'
            rootClassNames.push(props.theme.startLeft)
        }
    } else if (props.type === 'header') {
        rootClassNames.push(props.theme.closerVertical, styles.closerVerticalRight)
        if (props.windowState === windowStates.opened) {
            closerClass1 = 'fa fa-caret-up'
        } else {
            closerClass1 = 'fa fa-caret-down'
            rootClassNames.push(props.theme.startUp)
        }
    }

    const buttonStyle = {
        padding: '4px',
    }

    // TODO: fix maximize button
    return (
        <div>
            <div
                role="button"
                tabIndex="-1"
                className={rootClassNames.join(' ')}
            >
                <span style={buttonStyle} className={closerClass1} onClick={() => onChangeState(closerClass1)} />
                {closerClass2 && (
                    <span style={buttonStyle} className={closerClass2} onClick={() => onChangeState(closerClass2)} />
                )}
            </div>
        </div>
    )
}

WindowState.defaultProps = {
    theme: {},
}

export default WindowState
